import {
    validateEmail,
    validatePhoneNumber,
    validateWebSite
  } from 'utils';

export const formFields2_1 = [
  
    {
      id: 'companyName',
      label: 'Επωνυμία Προμηθευτή',
      type: 'text',
      name: 'companyName',
      size: 'large',
      placeholder: 'Εισάγετε Επωνυμία Προμηθευτή',
      span: 24,
      rules: [{ required: true, message: 'Το πεδίο είναι υποχρεωτικό' }],
      asterisk: true,
    },
    {
      id:'abiVat',
      label: 'Α.Φ.Μ.',
      type: 'text',
      name: 'abiVat',
      size: 'large',
      placeholder: 'Εισάγετε Α.Φ.Μ.',
      span: 24,
      asterisk: true,
      rules: [
        { required: true, message: 'Το πεδίο είναι υποχρεωτικό' },
        /*() => ({
          validator(_, value) {
            return validateAFM(value);
          },
        }),*/
      ],
    },
    {
      id: 'mainKAD',
      label: 'ΚΑΔ Κύριας Δραστηριότητας',
      type: 'text',
      name: 'mainKAD',
      size: 'large',
      placeholder: 'Εισάγετε ΚΑΔ Κύριας Δραστηριότητας',
      span: 24,
      rules: [{ required: true, message: 'Το πεδίο είναι υποχρεωτικό' }],
      asterisk: true,
    },
    {
      id: 'additionalKAD',
      label: 'Συμπληρωματικοί ΚΑΔ',
      type: 'text',
      name: 'additionalKAD',
      size: 'large',
      placeholder: 'Εισάγετε Συμπληρωματικό ΚΑΔ',
      span: 24,
      rules: [{ required: true, message: 'Το πεδίο είναι υποχρεωτικό' }],
      // asterisk: true,
    },
  ];

  export const formFields2_2 = [
    {
      id: 'abiStreetFull',
      label: 'Οδός - Αριθμός',
      type: 'text',
      name: 'abiStreetFull',
      size: 'large',
      placeholder: 'Εισάγετε Οδό - Αριθμό',
      span: 12,
      asterisk: true,
      rules: [{ required: true, message: 'Το πεδίο είναι υποχρεωτικό' }],
    },
    {
      id: 'abiTk',
      label: 'Τ.Κ.',
      type: 'text',
      name: 'abiTk',
      size: 'large',
      placeholder: 'Εισάγετε Τ.Κ.',
      span: 12,
      asterisk: true,
      rules: [{ required: true, message: 'Το πεδίο είναι υποχρεωτικό' }],
    },
    { 
      id: 'abiCity',
      label: 'Πόλη',
      title: 'Πόλη',
      type: 'text',
      name: 'abiCity',
      size: 'large',
      placeholder: 'Εισάγετε Πόλη',
      span: 12,
      asterisk: true,
      rules: [{ required: true, message: 'Το πεδίο είναι υποχρεωτικό' }],
      //disabled: true,
    },
    {
      id: 'abiCountry',
      label: 'Χώρα',
      title: 'Χώρα',
      type: 'text',
      name: 'abiCountry',
      size: 'large',
      placeholder: 'Εισάγετε Χώρα',
      span: 12,
      asterisk: true,
      rules: [{ required: true, message: 'Το πεδίο είναι υποχρεωτικό' }],
      //disabled: true,
    },
    {
      id: 'invMob',
      label: 'Τηλέφωνο',
      type: 'text',
      name: 'invMob',
      size: 'large',
      // maxLength: 10,
      placeholder: 'Εισάγετε Τηλέφωνο',
      span: 24,
      asterisk: true,
      rules: [{ required: true, message: 'Το πεδίο είναι υποχρεωτικό' }],
    },
    {
      id: 'website',
      label: 'Ιστοχώρος',
      type: 'text',
      name: 'website',
      size: 'large',
      placeholder: 'Εισάγετε Ιστοχώρο',
      span: 24,
      maxLength: 80,
      validateTrigger: 'onBlur',
      trigger: 'onBlur', 
      rules: [
        {
          validator: (_, value) => validateWebSite(value)
        }
      ],
    },
    {
      id: 'invMail',
      label: 'E-mail',
      type: 'text',
      name: 'invMail',
      size: 'large',
      placeholder: 'Εισάγετε E-mail',
      maxLength:50,
      span: 24,
      asterisk: true,
      rules: [
        { required: true, message: 'Το πεδίο είναι υποχρεωτικό' },
        {
          validator: (_, value) => validateEmail(value)
        }
      ],
    },
  ];

